import { useContext } from 'react';

import { useIsFeatureAvailable } from 'features';
import { SettingsContext } from 'settings';

export const useIsCashboxEnabled = (): boolean => {
  const isCashboxModuleIncluded = useIsFeatureAvailable('cash_box');
  const {
    state: {
      settings: { isCashboxEnabled, countryCode },
    },
  } = useContext(SettingsContext);

  return countryCode === 'RU' && isCashboxModuleIncluded && isCashboxEnabled;
};
